import { Box, useOpenClose } from '@palmetto/palmetto-components';

import { SabalInternalEvents } from 'types';

import { CollapsibleDetails } from './CollapsibleDetails';
import EventBy from './EventBy';

const WelcomeCallDecision = ({ event }: { event: any }) => {
  const { isOpen, handleToggle } = useOpenClose();
  const isApproved = event?.eventType === SabalInternalEvents.welcomeCallApproved;
  const note = event?.data?.reason;

  return (
    <Box display="block" childGap="sm">
      <Box display="block">
        <Box as="span" display="inline-block" margin="0 2xs 0 0" childGap="md">
          <EventBy event={event} /> {isApproved ? 'approved' : 'rejected'} the welcome call
        </Box>
      </Box>

      {note && (
        <CollapsibleDetails
          title={isApproved ? 'Approval Note' : 'Rejection Note'}
          isOpen={isOpen}
          onToggle={handleToggle}
        >
          {note}
        </CollapsibleDetails>
      )}
    </Box>
  );
};

export const WelcomeCallRecheckResult = ({ event }: { event: any }) => {
  const isPassed = event?.eventType === SabalInternalEvents.welcomeCallRecheckPassed;
  const disposition = event?.data?.disposition;

  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        {isPassed
          ? 'Recheck verification call passed'
          : `Recheck verification call did not pass${disposition ? ` (${disposition})` : ''} — sent for manual review`}
      </Box>
    </Box>
  );
};

export default WelcomeCallDecision;
